import React from "react";
import Select, { components } from "react-select";
import { css } from "react-emotion";

const customArrow = css`
  /* Positions background arrow image */
  background-image: url("data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAUCAYAAACNiR0NAAAA20lEQVQ4T+3SL0tDcRjF8c8V2YrJqHF1VTAIK5rtewGCb2BNWBIcmKy+gYW9ATGJIPblwZLNZBqMyQ9+Vy4/7j/wxj31Oc8XzjlPpuPJOubZA/+faJphDxPMsGnA96P2oahNgUd4xRpjbCugh5jjFJf4yXVlLR/jDR+4wS6BHuAZZxjhu7ivepsTvGMRbeXQoH/ENS7wlTqo+8NBhD7hPh7e4TbCVmVxND32MNoPoGB1Gm0uqwprAoa7c7xEwBU+69pvAwz3ockw4QNqpy2wifO33wNbR1Up7DzDX2zcHRV0yPnBAAAAAElFTkSuQmCC");
  background-repeat: no-repeat;
  background-position: 60px center;
`;

export default class SelectOptions extends React.Component {
  onSelect = (selectedOption) => {
    this.props.setValue(selectedOption.value);
  };
  arrowRenderer = () => {
    return <div className={customArrow}></div>;
  };

  render() {
    const {
      options,
      value,
      width,
      isDisabled,
      height,
      containerWidth,
      style,
      marginRight,
    } = this.props;
    // console.log("got value for select: " + value);
    // console.log(options);
    const colourStyles = {
      option: (styles, { data, isDisabled, isFocused, isSelected }) => {
        const fontFamily = data.font || "LucidaGrande";
        const color = isSelected ? "black" : "black";

        const backgroundColor = isSelected ? "#adadad" : "white";
        const indicatorSeparator = false;

        return {
          ...styles,
          fontFamily,
          indicatorSeparator,
          color,
          backgroundColor,

          cursor: "pointer",
          ":active": {
            ...styles[":active"],
            backgroundColor:
              !isDisabled && (isSelected ? data.color : "#89D2D3"),
          },
        };
      },
      dropdownIndicator: (styles, { data }) => ({
        ...styles,
        cursor: "pointer",
      }),
      indicatorSeparator: (styles, { data }) => ({
        ...styles,
        width: "0px",
        cursor: "pointer",
      }),
      singleValue: (styles, { data }) => {
        const indicatorSeparator = false;
        const fontFamily = data.font || "LucidaGrande";
        return {
          ...styles,
          fontFamily,
          indicatorSeparator,
        };
      },
      menu: (styles) => ({
        ...styles,
        width: containerWidth || width,
        height,
        // border: "1px solid #979797"
      }),
      container: (styles) => ({
        ...styles,
        width,
        height,
        marginRight: marginRight,
        display: "inline-block",
      }),
      menuList: (styles) => ({
        ...styles,
        width: containerWidth || width,
        height,
      }),
      control: (styles) => ({
        ...styles,
        width: containerWidth || width,
        height,
        // border: "none"
      }),
    };
    // console.log("got default: " + value);

    const currentValue = options.find((op) => {
      // console.log(op.value);
      // console.log(typeof op.value);
      return op.value === value;
    });
    // console.log(currentValue);

    return (
      <div style={style}>
        <Select
          isDisabled={isDisabled}
          defaultValue={currentValue}
          value={currentValue}
          options={options}
          onChange={this.onSelect}
          styles={colourStyles}
        />
      </div>
    );
  }
}
